<template>
  <div>
    <div
      class="d-flex align-item-center justify-content-between overflow-hidden"
      :class="{
        'justify-content-center': $store.getters['enums/operator'] === 'eJ',
      }"
      style="height: 100vh"
    >
      <div class="d-flex justify-content-center align-items-center mx-auto p-3 keycloak-container">
        <div>
          <div class="title mb-2" v-if="false">
            <img
              src="@/assets/images/fanoos-ramadan.png"
              alt="fanoos-ramadan"
              class="fanoos-ramadan"
              v-if="isRamadan"
            />
            <img
              v-if="$store.getters['enums/operator'] === 'eJ'"
              src="@/assets/logo/SSS/SAPTCO-Logo-01.png"
              alt="login-title-vector"
              width="350px"
            />
          </div>
          <div class="form">
            <div class="keycloak-form-header">
              <img src="@/assets/images/login-header.svg" alt="logo" />
              <p>{{ $t('login-header') }}</p>
            </div>
            <router-view v-slot="slotProps">
              <transition name="route" mode="out-in">
                <component :is="slotProps.Component"></component>
              </transition>
            </router-view>
          </div>
          <div class="bottom-container" v-if="false">
            <span> {{ $t('do-not-have-an-account-yet') }} </span>
            <span class="link"> {{ $t('sign-up-with-rekab') }} </span>
          </div>
        </div>
      </div>
      <div class="image-container d-none d-md-block">
        <div class="login-container">
          <button :style="buttonStyle" @click="toggleLang">
            {{ currentLang === 'ar' ? 'EN' : 'عربي' }}
          </button>
        </div>
        <img :src="loginImage" alt="login" class="login-image" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Auth',
  data() {
    return {
      isSaudiFoundingDay: false,
      isRamadan: false,
      isEid: false,
      isEidAdha: false,
      currentLang: localStorage.getItem('lang') || 'en',
    }
  },
  methods: {
    toggleLang() {
      this.currentLang = this.currentLang === 'ar' ? 'en' : 'ar'

      localStorage.setItem('lang', this.currentLang)
      this.$i18n.locale = this.currentLang

      document.documentElement.setAttribute('dir', this.currentLang === 'ar' ? 'rtl' : 'ltr')

      this.$router.replace({
        path: this.$route.path,
        query: { lang: this.currentLang },
      })
    },
  },
  computed: {
    loginImage() {
      if (this.isRamadan) {
        return require('@/assets/images/ramadan-theme.jpg')
      }
      if (this.isSaudiFoundingDay) {
        return require('@/assets/images/saudi-founding-day.jpg')
      }
      if (this.isEid) {
        return require('@/assets/images/eid-theme.png')
      }
      if (this.isEidAdha) {
        return require('@/assets/images/eid-adha-theme.jpg')
      }
      return require('@/assets/images/sekaya_logo_new.png')
    },
    buttonStyle() {
      if (this.currentLang === 'ar') {
        return {
          position: 'absolute',
          left: '0px',
          zIndex: '999999',
          backgroundColor: '#FFF',
          border: 'none',
          borderRadius: '0.375rem',
          cursor: 'pointer',
          transition: 'background-color 0.15s ease-in-out, transform 0.1s ease',
          color: '#154593',
          padding: '10px',
          margin: '12px',
        }
      } else {
        return {
          position: 'absolute',
          zIndex: '999999',
          right: '0px',
          backgroundColor: '#FFF',
          border: 'none',
          borderRadius: '0.375rem',
          cursor: 'pointer',
          transition: 'background-color 0.15s ease-in-out, transform 0.1s ease',
          color: '#154593',
          padding: '10px',
          margin: '12px',
        }
      }
    },
  },
  mounted() {
    const lang = this.$route.query.lang || localStorage.getItem('lang') || 'en'

    this.$i18n.locale = lang
    localStorage.setItem('lang', lang)

    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr')
  },
  watch: {
    '$i18n.locale'(newLang) {
      document.documentElement.setAttribute('dir', newLang === 'ar' ? 'rtl' : 'ltr')
    },
  },
  i18n: {
    messages: {
      en: require('@/services/i18n/locales/en/auth.json'),
      ar: require('@/services/i18n/locales/ar/auth.json'),
    },
  },
}
</script>

<style lang="scss">
.form-container {
  padding: 2rem;
  position: relative;

  .link {
    font-weight: 700;
    font-size: 12px;
    color: var(--color-23);
    cursor: pointer;
  }

  .bottom-container {
    position: absolute;
    bottom: 50px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    color: var(--color-02);
  }
}

.keycloak-container {
  width: 50%;

  .keycloak-form-header {
    max-width: 380px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
  }

  p {
    font-size: 14px;
    line-height: 20px;
    font-weight: 300;
    text-align: center;
  }
}

.image-container {
  position: relative;
  width: 50%;

  .login-vector {
    position: absolute;
    top: 30px;
    left: 30px;
  }

  .login-image {
    height: 100%;
    width: 100%;
    // object-fit: contain;
  }
}

.fanoos-ramadan {
  width: 40px;
  position: absolute;
  inset-block-start: -10px;
  inset-inline-start: 34px;
  animation: swing 25s ease-in-out infinite;
  transform-origin: 50% 0%;
}

@keyframes swing {
  0%,
  80%,
  100% {
    transform: rotate(0deg);
  }

  10% {
    transform: rotate(20deg);
  }

  20% {
    transform: rotate(-15deg);
  }

  30% {
    transform: rotate(10deg);
  }

  40% {
    transform: rotate(-5deg);
  }

  50% {
    transform: rotate(3deg);
  }

  60% {
    transform: rotate(-2deg);
  }

  70%,
  90% {
    transform: rotate(1deg);
  }
}

@media (min-width: 992px) {
  .app {
    .form-container {
      margin-inline-start: 6rem !important;
    }
  }
}
</style>
